import styles from "./styles/tab-button.module.scss";
import React, { ReactNode } from "react";

interface TabButtonProps<T extends string> {
  type: T;
  selectedSubtype: T;
  setSubtype: (type: T) => void;
  children?: ReactNode;
  overriddenNotSelected?: string;
}

const TabButton = <T extends string>({
  type,
  selectedSubtype,
  setSubtype,
  children,
  overriddenNotSelected,
}: TabButtonProps<T>) => {
  return (
    <button
      className={`${styles.button} ${selectedSubtype === type ? styles.selected_button : overriddenNotSelected ?? styles.not_selected_button}`}
      onClick={() => setSubtype(type)}
    >
      {children ?? type.toString()}
    </button>
  );
};

export default TabButton;
